export const numberFormat = new Intl.NumberFormat('en-us', {});

export const currencyFormat = new Intl.NumberFormat('en-us', {
  style: 'currency',
  currency: 'USD'
});

export const percentFormat = new Intl.NumberFormat('en-us', {
  style: 'percent'
});

export const compactNumberFormat = new Intl.NumberFormat('en-us', {
  notation: 'compact',
  compactDisplay: 'short'
});

export const compactCurrencyFormat = new Intl.NumberFormat('en-us', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact'
});

export const compactPercentFormat = new Intl.NumberFormat('en-us', {
  style: 'percent',
  notation: 'compact'
});

export function roundNumber(value: number, precision: number): number {
  if (!Number.isFinite(value)) {
    throw new TypeError('Value must be a finite number');
  }
  if (!Number.isInteger(precision) || precision < 0) {
    throw new TypeError('Precision must be a non-negative integer');
  }

  const sign = value < 0 ? -1 : 1;
  const abs = Math.abs(value);

  const shifted = Number(`${abs}e${precision}`);
  const rounded = Math.round(shifted);
  const result = sign * Number(`${rounded}e${-precision}`);

  return Object.is(result, -0) ? 0 : result;
}

export function ceilNumber(value: number, precision: number): number {
  if (!Number.isFinite(value)) {
    throw new TypeError(`Value must be a finite number: ${value}`);
  }
  if (!Number.isInteger(precision) || precision < 0) {
    throw new TypeError(
      `Precision must be a non-negative integer: ${precision}`
    );
  }

  const shifted = Number(`${value}e${precision}`);

  if (!Number.isFinite(shifted)) {
    throw new RangeError(
      `Cannot ceil number: value ${value} with precision ${precision} is outside the supported range`
    );
  }

  const tolerance = Number.EPSILON * Math.max(1, Math.abs(shifted));
  const ceiled = Math.ceil(shifted - tolerance);
  const result = Number(`${ceiled}e${-precision}`);

  if (!Number.isFinite(result)) {
    throw new RangeError(
      `Cannot ceil number: value ${value} with precision ${precision} produced a non-finite result`
    );
  }

  return Object.is(result, -0) ? 0 : result;
}
